import React from 'react';

import { useAppTakeoverPdp } from 'components/app-takeover/use-app-takeover';
import { useProductWizardContext } from 'pages/menu/components/product-wizard';
import { ProductWizardStep } from 'pages/menu/components/product-wizard/types';
import { useProductWizardFlow } from 'pages/menu/components/product-wizard/use-product-wizard-flow';
import { primitive } from 'styles/constants/primitives';

import { ComboSlotType } from '../../product-customization/types';
import { ProductDetailBackArrow } from '../product-detail-back-arrow';
import { ProductDetailClose } from '../product-detail-close';

import { Container, ProductDetailFlowHeaderContainer, ProductTitle } from './styled';

interface IProductDetailHeader {
  comboSlotType?: ComboSlotType;

  /**
   * Used to be optional and had logic to figure out the title based on context, now each component is responsible for passing the title
   * You can figure out which title to pass by looking at the previous implementation here:
   * src/components/product-detail-v2/product-detail-flow/product-detail-header/use-product-detail-header.ts
   * TODO: remove this comment after all components have been updated
   */
  title: string;
}

export const ProductDetailHeader: React.FC<IProductDetailHeader> = ({ title }) => {
  const { currentFlowStep, cartIdEditing, goToPreviousStep, id } = useProductWizardFlow();
  const {
    headerBackgroundColor: takeoverHeaderBg,
    fontFamily: takeoverFontFamily,
    HeaderFlair,
  } = useAppTakeoverPdp(id);

  const { setShowCloseDialog } = useProductWizardContext();

  const showCloseButton = currentFlowStep.step !== ProductWizardStep.ProductCustomization;
  const showBackArrow = currentFlowStep.step !== ProductWizardStep.ProductHome;

  const handleClose = () => {
    if (currentFlowStep.step === ProductWizardStep.ProductHome || cartIdEditing) {
      return goToPreviousStep();
    }
    setShowCloseDialog(true);
  };

  const currentStep = currentFlowStep.step;

  return (
    <ProductDetailFlowHeaderContainer
      testID="product-detail-flow-header"
      backgroundColor={
        takeoverHeaderBg ||
        (currentStep === ProductWizardStep.ProductHome
          ? primitive.bk.$mayoEggWhite
          : primitive.$white)
      }
    >
      {HeaderFlair && <HeaderFlair />}
      <Container>
        {showBackArrow && <ProductDetailBackArrow onPress={goToPreviousStep} />}
        {showCloseButton && <ProductDetailClose onDismiss={handleClose} />}
        <ProductTitle fontFamily={takeoverFontFamily}>{title}</ProductTitle>
      </Container>
    </ProductDetailFlowHeaderContainer>
  );
};
